import { render, staticRenderFns } from "./PaymentMethodDropdown.vue?vue&type=template&id=5694997e"
import script from "./PaymentMethodDropdown.vue?vue&type=script&lang=js"
export * from "./PaymentMethodDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports